import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-inksoft animate-pulse">
                    Loading…
                </div>
            </div>
        );
    }

    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
